import { SentimentPolarityRange } from 'app/providers/storage-api/project.service';

export class SentimentUtils {
  private static readonly DEFAULT_RANGES = {
    document: {
      3: [
        { sentimentPolarity: 'negative', min: null, max: -0.1 },
        { sentimentPolarity: 'neutral', min: -0.1, max: 0.2 },
        { sentimentPolarity: 'positive', min: 0.2, max: null },
      ],
      5: [
        { sentimentPolarity: 'very negative', min: null, max: -0.4 },
        { sentimentPolarity: 'somewhat negative', min: -0.4, max: -0.2 },
        { sentimentPolarity: 'neutral', min: -0.2, max: 0.2 },
        { sentimentPolarity: 'somewhat positive', min: 0.2, max: 0.4 },
        { sentimentPolarity: 'very positive', min: 0.4, max: null },
      ],
    },
    feature: {
      3: [
        { sentimentPolarity: 'negative', min: null, max: -0.5 },
        { sentimentPolarity: 'neutral', min: -0.5, max: 0.5 },
        { sentimentPolarity: 'positive', min: 0.5, max: null },
      ],
      5: [
        { sentimentPolarity: 'very negative', min: null, max: -0.4 },
        { sentimentPolarity: 'somewhat negative', min: -0.4, max: -0.2 },
        { sentimentPolarity: 'neutral', min: -0.2, max: 0.2 },
        { sentimentPolarity: 'somewhat positive', min: 0.2, max: 0.4 },
        { sentimentPolarity: 'very positive', min: 0.4, max: null },
      ],
    },
  };
  static getSentimentValueFromRange(
    score: number,
    sentimentRanges: SentimentPolarityRange[],
    sentimentScale: number
  ): string {
    if (sentimentScale === 3) {
      if (score <= sentimentRanges[0].max) {
        return sentimentRanges[0].sentimentPolarity;
      } else if (score >= sentimentRanges[2].min) {
        return sentimentRanges[2].sentimentPolarity;
      } else {
        return sentimentRanges[1].sentimentPolarity;
      }
    } else {
      if (score <= sentimentRanges[0].max) {
        return sentimentRanges[0].sentimentPolarity;
      } else if (score > sentimentRanges[1].min && score <= sentimentRanges[1].max) {
        return sentimentRanges[1].sentimentPolarity;
      } else if (score > sentimentRanges[2].min && score < sentimentRanges[2].max) {
        return sentimentRanges[2].sentimentPolarity;
      } else if (score >= sentimentRanges[3].min && score < sentimentRanges[3].max) {
        return sentimentRanges[3].sentimentPolarity;
      } else {
        return sentimentRanges[4].sentimentPolarity;
      }
    }
  }

  static getDefaultSentimentRanges(type?: 'document' | 'feature', scale?: number) {
    if (type) {
      if (scale) {
        return this.DEFAULT_RANGES[type][scale].map((s) => ({ ...s }));
      }
      return this.DEFAULT_RANGES[type];
    }
    return this.DEFAULT_RANGES;
  }
}
